import React from "react";
import { Form, Select } from "antd";
import { SecurePassAutoSend } from "@/utils/enum";
import { Validator } from "@/utils/validator";
import SecurePassLabel from "@/components/SecurePass/SecurePassLabel/SecurePassLabel";

const SecurePassDropdown = ({ label, name }) => (
  <Form.Item
    name={name}
    label={label}
    rules={[Validator.required("Please select a secure pass type")]}
    initialValue={SecurePassAutoSend.DEFAULT}
    normalize={value => {
      if (value === 0 || value === undefined || value === null) {
        return SecurePassAutoSend.DEFAULT;
      }
      return value;
    }}
  >
    <Select getPopupContainer={trigger => trigger.parentElement}>
      {Object.values(SecurePassAutoSend).map(type => (
        <Select.Option key={type} value={type}>
          <SecurePassLabel securePassValue={type} />
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);

export default SecurePassDropdown;
